/**
Author - Brijesh Pandey
Git - https://bitbucket.org/__brijesh/
**/

import NomineeDetails from "./NomineeDetails.container";

export default NomineeDetails;
